"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _possibleConstructorReturn(t, e) { if (e && ("object" == _typeof(e) || "function" == typeof e)) return e; if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined"); return _assertThisInitialized(t); }
function _assertThisInitialized(e) { if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); return e; }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
function _getPrototypeOf(t) { return _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (t) { return t.__proto__ || Object.getPrototypeOf(t); }, _getPrototypeOf(t); }
function _inherits(t, e) { if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function"); t.prototype = Object.create(e && e.prototype, { constructor: { value: t, writable: !0, configurable: !0 } }), Object.defineProperty(t, "prototype", { writable: !1 }), e && _setPrototypeOf(t, e); }
function _setPrototypeOf(t, e) { return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) { return t.__proto__ = e, t; }, _setPrototypeOf(t, e); }
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
(function () {
  var _React = React,
    useState = _React.useState,
    useEffect = _React.useEffect,
    useRef = _React.useRef;

  // Waveforms come from THE SHARED RHYTHM REGISTRY (data/rhythms.js): ECG complexes in real time
  // (seconds), per-lead morphology, and beat-by-beat pleth and arterial pulses that follow every
  // QRS. Nothing here keeps a private copy of a waveform.
  var RG = window.RHYTHMS;
  if (!RG) throw new Error('data/rhythms.js must load before data/components.js');

  // Chest-wall impedance over one breath (0 = start of inspiration). It uses the SAME breath
  // timing as the capnogram (RHYTHMS.breathTiming), so the impedance rises exactly while the
  // capnogram sits on its inspiratory baseline. Expiration falls back to the resting level and
  // then waits there through any expiratory pause.
  var respImpedance = function respImpedance(cycle, rate) {
    var bt = RG.breathTiming(rate);
    var t = cycle * bt.T;
    if (t < bt.Ti) return -15 * Math.cos(Math.PI * t / bt.Ti);
    var fall = Math.min(bt.T - bt.Ti, 2 * bt.Ti);
    return t - bt.Ti < fall ? 15 * Math.cos(Math.PI * (t - bt.Ti) / fall) : -15;
  };
  var Lucide = function Lucide(_ref) {
    var icon = _ref.icon,
      className = _ref.className,
      onClick = _ref.onClick;
    var icons = {
      'activity': '<polyline points="22 12 18 12 15 21 9 3 6 12 2 12"></polyline>',
      'chevron-down': '<polyline points="6 9 12 15 18 9"></polyline>',
      'chevron-right': '<polyline points="9 18 15 12 9 6"></polyline>',
      'heart-pulse': '<path d="M19 14c1.49-1.46 3-3.21 3-5.5A5.5 5.5 0 0 0 16.5 3c-1.76 0-3 .5-4.5 2-1.5-1.5-2.74-2-4.5-2A5.5 5.5 0 0 0 2 8.5c0 2.3 1.5 4.05 3 5.5l7 7Z"/><path d="M12 5 9.04 11H6"/><path d="M12 5l3 6h3"/>',
      'shuffle': '<path d="M2 18h1.4c1.3 0 2.5-.6 3.3-1.7l6.1-8.6c.7-1.1 2-1.7 3.3-1.7H22"/><path d="m18 2 4 4-4 4"/><path d="M2 6h1.9c1.5 0 2.9.9 3.6 2.2"/><path d="M22 18h-5.9c-1.3 0-2.6-.7-3.3-1.8l-.5-.8"/><path d="m18 14 4 4-4 4"/>',
      'folder': '<path d="M20 20a2 2 0 0 0 2-2V8a2 2 0 0 0-2-2h-7.9a2 2 0 0 1-1.69-.9L9.6 3.9A2 2 0 0 0 7.93 3H4a2 2 0 0 0-2 2v13a2 2 0 0 0 2 2Z"/>',
      'book-open': '<path d="M2 3h6a4 4 0 0 1 4 4v14a3 3 0 0 0-3-3H2z"/><path d="M22 3h-6a4 4 0 0 0-4 4v14a3 3 0 0 1 3-3h7z"/>',
      'zap': '<polygon points="13 2 3 14 12 14 11 22 21 10 12 10 13 2"></polygon>',
      'laptop': '<path d="M20 16V7a2 2 0 0 0-2-2H6a2 2 0 0 0-2 2v9m16 0H4m16 0 1.28 2.55a1 1 0 0 1-.9 1.45H3.62a1 1 0 0 1-.9-1.45L4 16"/>',
      'tablet': '<rect width="16" height="20" x="4" y="2" rx="2" ry="2"/><line x1="12" x2="12.01" y1="18" y2="18"/>',
      'wind': '<path d="M17.7 7.7a2.5 2.5 0 1 1 1.8 4.3H2"/><path d="M9.6 4.6A2 2 0 1 1 11 8H2"/><path d="M12.6 19.4A2 2 0 1 0 14 16H2"/>',
      'bed': '<path d="M2 4v16"/><path d="M2 8h18a2 2 0 0 1 2 2v10"/><path d="M2 17h20"/><path d="M6 8v9"/>',
      'droplet': '<path d="M12 22a7 7 0 0 0 7-7c0-2-1-3.9-3-5.5s-3.5-4-4-6.5c-.5 2.5-2 4.9-4 6.5C6 11.1 5 13 5 15a7 7 0 0 0 7 7z"></path>',
      'thermometer': '<path d="M14 14.76V3.5a2.5 2.5 0 0 0-5 0v11.26a4.5 4.5 0 1 0 5 0z"></path>',
      'loader-2': '<path d="M21 12a9 9 0 1 1-6.219-8.56"></path>',
      'alert-triangle': '<path d="M10.29 3.86L1.82 18a2 2 0 0 0 1.71 3h16.94a2 2 0 0 0 1.71-3L13.71 3.86a2 2 0 0 0-3.42 0z"></path><line x1="12" y1="9" x2="12" y2="13"></line><line x1="12" y1="17" x2="12.01" y2="17"></line>',
      'check-circle': '<path d="M22 11.08V12a10 10 0 1 1-5.93-9.14"></path><polyline points="22 4 12 14.01 9 11.01"></polyline>',
      'x': '<line x1="18" y1="6" x2="6" y2="18"></line><line x1="6" y1="6" x2="18" y2="18"></line>',
      'menu': '<line x1="4" y1="12" x2="20" y2="12"></line><line x1="4" y1="6" x2="20" y2="6"></line><line x1="4" y1="18" x2="20" y2="18"></line>',
      'play': '<polygon points="5 3 19 12 5 21 5 3"></polygon>',
      'pause': '<rect x="6" y="4" width="4" height="16"></rect><rect x="14" y="4" width="4" height="16"></rect>',
      'square': '<rect x="3" y="3" width="18" height="18" rx="2" ry="2"></rect>',
      'volume-2': '<polygon points="11 5 6 9 2 9 2 15 6 15 11 19 11 5"></polygon><path d="M19.07 4.93a10 10 0 0 1 0 14.14M15.54 8.46a5 5 0 0 1 0 7.07"></path>',
      'volume-x': '<polygon points="11 5 6 9 2 9 2 15 6 15 11 19 11 5"></polygon><line x1="23" y1="9" x2="17" y2="15"></line><line x1="17" y1="9" x2="23" y2="15"></line>',
      'arrow-left': '<line x1="19" y1="12" x2="5" y2="12"></line><polyline points="12 19 5 12 12 5"></polyline>',
      'clock': '<circle cx="12" cy="12" r="10"></circle><polyline points="12 6 12 12 16 14"></polyline>',
      'list': '<line x1="8" y1="6" x2="21" y2="6"></line><line x1="8" y1="12" x2="21" y2="12"></line><line x1="8" y1="18" x2="21" y2="18"></line><line x1="3" y1="6" x2="3.01" y2="6"></line><line x1="3" y1="12" x2="3.01" y2="12"></line><line x1="3" y1="18" x2="3.01" y2="18"></line>',
      'monitor': '<rect x="2" y="3" width="20" height="14" rx="2" ry="2"></rect><line x1="8" y1="21" x2="16" y2="21"></line><line x1="12" y1="17" x2="12" y2="21"></line>',
      'user': '<path d="M20 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2"></path><circle cx="12" cy="7" r="4"></circle>',
      'info': '<circle cx="12" cy="12" r="10"></circle><line x1="12" y1="16" x2="12" y2="12"></line><line x1="12" y1="8" x2="12.01" y2="8"></line>',
      'mic': '<path d="M12 1a3 3 0 0 0-3 3v8a3 3 0 0 0 6 0V4a3 3 0 0 0-3-3z"></path><path d="M19 10v2a7 7 0 0 1-14 0v-2"></path><line x1="12" y1="19" x2="12" y2="23"></line><line x1="8" y1="23" x2="16" y2="23"></line>',
      'message-square': '<path d="M21 15a2 2 0 0 1-2 2H7l-4 4V5a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2z"></path>',
      'minus': '<line x1="5" y1="12" x2="19" y2="12"></line>',
      'flag': '<path d="M4 15s1-1 4-1 5 2 8 2 4-1 4-1V3s-1 1-4 1-5-2-8-2-4 1-4 1z"></path><line x1="4" y1="22" x2="4" y2="15"></line>',
      'stethoscope': '<path d="M4.8 2.3A5 5 0 0 0 3.8 7C2 7 0 9 0 12c0 2.2 1.6 4.3 3.5 4.9a5 5 0 0 0 .5-3.6"></path><path d="M22 10v7a2 2 0 0 1-2 2h-2a2 2 0 0 1-2-2v-7"></path><path d="M17 10V6a2 2 0 0 0-2-2h-3a2 2 0 0 0-2 2v1"></path><path d="M7 3v4a2 2 0 0 1-2 2H4"></path>',
      'ambulance': '<rect x="1" y="3" width="15" height="13"></rect><polygon points="16 8 20 8 23 11 23 16 16 16 16 8"></polygon><circle cx="5.5" cy="18.5" r="2.5"></circle><circle cx="18.5" cy="18.5" r="2.5"></circle>',
      'baby': '<path d="M9 12h.01"></path><path d="M15 12h.01"></path><path d="M10 16c.5.3 1.2.5 2 .5s1.5-.2 2-.5"></path><path d="M19 6.3a9 9 0 0 1 1.8 3.9 2 2 0 0 1 0 3.6 9 9 0 0 1-17.6 0 2 2 0 0 1 0-3.6A9 9 0 0 1 12 3c2 0 4 .5 5.7 1.6"></path><path d="M12 2v1"></path>',
      'skull': '<path d="m11.5 13.5-3.5 4"></path><path d="m12.5 13.5 3.5 4"></path><circle cx="9" cy="7" r="1.5"></circle><circle cx="15" cy="7" r="1.5"></circle><path d="M8 11.5v-1a4 4 0 0 1 8 0v1"></path><path d="M10.5 16.5h3"></path><path d="M22 12c0 5.5-4.5 10-10 10S2 17.5 2 12 6.5 2 12 2s10 4.5 10 10Z"></path>',
      'brain': '<path d="M9.5 2A2.5 2.5 0 0 1 12 4.5v15a2.5 2.5 0 0 1-4.96.44 2.5 2.5 0 0 1-2.96-3.08 3 3 0 0 1-.34-5.58 2.5 2.5 0 0 1 1.32-4.24 2.5 2.5 0 0 1 1.98-3A2.5 2.5 0 0 1 9.5 2Z"></path><path d="M14.5 2A2.5 2.5 0 0 0 12 4.5v15a2.5 2.5 0 0 0 4.96.44 2.5 2.5 0 0 0 2.96-3.08 3 3 0 0 0 .34-5.58 2.5 2.5 0 0 0-1.32-4.24 2.5 2.5 0 0 0-1.98-3A2.5 2.5 0 0 0 14.5 2Z"></path>',
      'clipboard-check': '<rect x="9" y="9" width="13" height="13" rx="2" ry="2"></rect><path d="M5 15H4a2 2 0 0 1-2-2V4a2 2 0 0 1 2-2h9a2 2 0 0 1 2 2v1"></path><path d="M14 13l2 2 4-4"></path>',
      'external-link': '<path d="M18 13v6a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V8a2 2 0 0 1 2-2h6"></path><polyline points="15 3 21 3 21 9"></polyline><line x1="10" y1="14" x2="21" y2="3"></line>',
      'scan': '<path d="M3 7V5a2 2 0 0 1 2-2h2"></path><path d="M17 3h2a2 2 0 0 1 2 2v2"></path><path d="M21 17v2a2 2 0 0 1-2 2h-2"></path><path d="M7 21H5a2 2 0 0 1-2-2v-2"></path>',
      'image': '<rect width="18" height="18" x="3" y="3" rx="2" ry="2"></rect><circle cx="9" cy="9" r="2"></circle><path d="m21 15-3.086-3.086a2 2 0 0 0-2.828 0L6 21"></path>',
      'flask-conical': '<path d="M10 2v7.527a2 2 0 0 1-.211.896L4.72 20.55a1 1 0 0 0 .9 1.45h12.76a1 1 0 0 0 .9-1.45l-5.069-10.127A2 2 0 0 1 14 9.527V2"></path><line x1="8.5" y1="2" x2="15.5" y2="2"></line><line x1="8.5" y1="14" x2="15.5" y2="14"></line>',
      'waves': '<path d="M2 6c.6.5 1.2 1 2.5 1C7 7 7 5 9.5 5c2.6 0 2.4 2 5 2 2.5 0 2.5-2 5-2 1.3 0 1.9.5 2.5 1"></path><path d="M2 12c.6.5 1.2 1 2.5 1 2.5 0 2.5-2 5-2 2.6 0 2.4 2 5 2 2.5 0 2.5-2 5-2 1.3 0 1.9.5 2.5 1"></path><path d="M2 18c.6.5 1.2 1 2.5 1 2.5 0 2.5-2 5-2 2.6 0 2.4 2 5 2 2.5 0 2.5-2 5-2 1.3 0 1.9.5 2.5 1"></path>',
      'check-square': '<polyline points="9 11 12 14 22 4"></polyline><path d="M21 12v7a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h11"></path>',
      // The "partly done" state of a multi-component learning objective. Lucide
      // returns an EMPTY glyph for an unknown name, so a missing icon renders as blank space.
      'minus-square': '<rect x="3" y="3" width="18" height="18" rx="2" ry="2"></rect><line x1="8" y1="12" x2="16" y2="12"></line>',
      'download': '<path d="M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4"></path><polyline points="7 10 12 15 17 10"></polyline><line x1="12" y1="15" x2="12" y2="3"></line>',
      'wifi': '<path d="M5 12.55a11 11 0 0 1 14.08 0"></path><path d="M1.42 9a16 16 0 0 1 21.16 0"></path><path d="M8.53 16.11a6 6 0 0 1 6.95 0"></path><line x1="12" y1="20" x2="12.01" y2="20"></line>',
      'pill': '<path d="m10.5 20.5 10-10a4.95 4.95 0 1 0-7-7l-10 10a4.95 4.95 0 1 0 7 7Z"></path><path d="m8.5 8.5 7 7"></path>',
      'bell': '<path d="M6 8a6 6 0 0 1 12 0c0 7 3 9 3 9H3s3-2 3-9"/><path d="M10.3 21a1.94 1.94 0 0 0 3.4 0"/>',
      'settings': '<path d="M12.22 2h-.44a2 2 0 0 0-2 2v.18a2 2 0 0 1-1 1.73l-.43.25a2 2 0 0 1-2 0l-.15-.08a2 2 0 0 0-2.73.73l-.22.38a2 2 0 0 0 .73 2.73l.15.1a2 2 0 0 1 1 1.72v.51a2 2 0 0 1-1 1.74l-.15.09a2 2 0 0 0-.73 2.73l.22.38a2 2 0 0 0 2.73.73l.15-.08a2 2 0 0 1 2 0l.43.25a2 2 0 0 1 1 1.73V20a2 2 0 0 0 2 2h.44a2 2 0 0 0 2-2v-.18a2 2 0 0 1 1-1.73l.43-.25a2 2 0 0 1 2 0l.15.08a2 2 0 0 0 2.73-.73l.22-.39a2 2 0 0 0-.73-2.73l-.15-.08a2 2 0 0 1-1-1.74v-.5a2 2 0 0 1 1-1.74l.15-.09a2 2 0 0 0 .73-2.73l-.22-.38a2 2 0 0 0-2.73-.73l-.15.08a2 2 0 0 1-2 0l-.43-.25a2 2 0 0 1-1-1.73V4a2 2 0 0 0-2-2z"></path><circle cx="12" cy="12" r="3"></circle>',
      'check': '<polyline points="20 6 9 17 4 12"></polyline>',
      'heart': '<path d="M19 14c1.49-1.46 3-3.21 3-5.5A5.5 5.5 0 0 0 16.5 3c-1.76 0-3 .5-4.5 2-1.5-1.5-2.74-2-4.5-2A5.5 5.5 0 0 0 2 8.5c0 2.3 1.5 4.05 3 5.5l7 7Z"/>',
      // These were referenced by Wave 3 code (the presence badge and sync
      // badge) and by the new account UI, but had no glyph, so they rendered as an empty
      // <svg>. Silently-blank icons are exactly the misleading dead code this wave removes.
      'wifi-off': '<line x1="2" y1="2" x2="22" y2="22"/><path d="M8.5 16.5a5 5 0 0 1 7 0"/><path d="M2 8.82a15 15 0 0 1 4.17-2.65"/><path d="M10.66 5c4.01-.36 8.14.9 11.34 3.76"/><path d="M16.85 11.25a10 10 0 0 1 2.22 1.68"/><path d="M5 13a10 10 0 0 1 5.24-2.76"/><line x1="12" y1="20" x2="12.01" y2="20"/>',
      'monitor-off': '<path d="M17 17H4a2 2 0 0 1-2-2V5c0-1.5 1-2 1-2"/><path d="M22 15V5a2 2 0 0 0-2-2H9"/><path d="M8 21h8"/><path d="M12 17v4"/><line x1="2" y1="2" x2="22" y2="22"/>',
      'shield': '<path d="M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z"/>',
      'log-in': '<path d="M15 3h4a2 2 0 0 1 2 2v14a2 2 0 0 1-2 2h-4"/><polyline points="10 17 15 12 10 7"/><line x1="15" y1="12" x2="3" y2="12"/>',
      'lock': '<rect x="3" y="11" width="18" height="11" rx="2"/><path d="M7 11V7a5 5 0 0 1 10 0v4"/>',
      'unlock': '<rect x="3" y="11" width="18" height="11" rx="2"/><path d="M7 11V7a5 5 0 0 1 9.9-1"/>',
      'sliders': '<line x1="4" y1="21" x2="4" y2="14"/><line x1="4" y1="10" x2="4" y2="3"/><line x1="12" y1="21" x2="12" y2="12"/><line x1="12" y1="8" x2="12" y2="3"/><line x1="20" y1="21" x2="20" y2="16"/><line x1="20" y1="12" x2="20" y2="3"/><line x1="1" y1="14" x2="7" y2="14"/><line x1="9" y1="8" x2="15" y2="8"/><line x1="17" y1="16" x2="23" y2="16"/>',
      'upload': '<path d="M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4"></path><polyline points="17 8 12 3 7 8"></polyline><line x1="12" y1="3" x2="12" y2="15"></line>',
      'maximize': '<path d="M8 3H5a2 2 0 0 0-2 2v3"/><path d="M21 8V5a2 2 0 0 0-2-2h-3"/><path d="M3 16v3a2 2 0 0 0 2 2h3"/><path d="M16 21h3a2 2 0 0 0 2-2v-3"/>',
      'minimize': '<path d="M8 3v3a2 2 0 0 1-2 2H3"/><path d="M21 8h-3a2 2 0 0 1-2-2V3"/><path d="M3 16h3a2 2 0 0 1 2 2v3"/><path d="M16 21v-3a2 2 0 0 1 2-2h3"/>',
      'qr-code': '<rect x="3" y="3" width="7" height="7" rx="1"/><rect x="14" y="3" width="7" height="7" rx="1"/><rect x="3" y="14" width="7" height="7" rx="1"/><path d="M14 14h3v3h-3z"/><path d="M20 14v7"/><path d="M14 20h3"/>',
      'printer': '<polyline points="6 9 6 2 18 2 18 9"/><path d="M6 18H4a2 2 0 0 1-2-2v-5a2 2 0 0 1 2-2h16a2 2 0 0 1 2 2v5a2 2 0 0 1-2 2h-2"/><rect x="6" y="14" width="12" height="8"/>',
      'sun': '<circle cx="12" cy="12" r="4"/><path d="M12 2v2"/><path d="M12 20v2"/><path d="M4.93 4.93l1.41 1.41"/><path d="M17.66 17.66l1.41 1.41"/><path d="M2 12h2"/><path d="M20 12h2"/><path d="M6.34 17.66l-1.41 1.41"/><path d="M19.07 4.93l-1.41 1.41"/>'
    };
    return /*#__PURE__*/React.createElement("svg", {
      xmlns: "http://www.w3.org/2000/svg",
      width: "24",
      height: "24",
      viewBox: "0 0 24 24",
      fill: "none",
      stroke: "currentColor",
      strokeWidth: "2",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      className: className,
      onClick: onClick,
      dangerouslySetInnerHTML: {
        __html: icons[icon] || ''
      }
    });
  };

  // `type` is threaded through so a Button can be a real form submit control (the
  // account sign-in form). Default stays 'button' so no existing Button inside a form can
  // accidentally start submitting.
  var Button = function Button(_ref2) {
    var children = _ref2.children,
      onClick = _ref2.onClick,
      _ref2$variant = _ref2.variant,
      variant = _ref2$variant === void 0 ? 'primary' : _ref2$variant,
      _ref2$className = _ref2.className,
      className = _ref2$className === void 0 ? '' : _ref2$className,
      _ref2$disabled = _ref2.disabled,
      disabled = _ref2$disabled === void 0 ? false : _ref2$disabled,
      _ref2$size = _ref2.size,
      size = _ref2$size === void 0 ? 'md' : _ref2$size,
      _ref2$href = _ref2.href,
      href = _ref2$href === void 0 ? null : _ref2$href,
      _ref2$target = _ref2.target,
      target = _ref2$target === void 0 ? null : _ref2$target,
      _ref2$ariaLabel = _ref2.ariaLabel,
      ariaLabel = _ref2$ariaLabel === void 0 ? null : _ref2$ariaLabel,
      _ref2$type = _ref2.type,
      type = _ref2$type === void 0 ? 'button' : _ref2$type;
    var baseClass = "rounded font-bold transition-all active:scale-95 flex items-center justify-center gap-1.5";
    var variants = {
      primary: "bg-sky-700 hover:bg-sky-600 text-white shadow-lg shadow-sky-900/50 border border-sky-500",
      secondary: "bg-slate-700 hover:bg-slate-600 text-slate-200 border border-slate-600",
      danger: "bg-red-700 hover:bg-red-600 text-white shadow-lg shadow-red-900/50 border border-red-500",
      success: "bg-emerald-700 hover:bg-emerald-600 text-white shadow-lg shadow-emerald-900/50 border border-emerald-500",
      warning: "bg-amber-700 hover:bg-amber-600 text-white shadow-lg shadow-amber-900/50 border border-amber-500",
      outline: "bg-transparent border border-slate-600 text-slate-400 hover:border-slate-400 hover:text-slate-200"
    };
    var sizes = {
      sm: "px-2 py-1 text-xs",
      md: "px-4 py-2 text-sm",
      lg: "px-6 py-3 text-lg"
    };
    var classes = "".concat(baseClass, " ").concat(variants[variant], " ").concat(sizes[size], " ").concat(className, " ").concat(disabled ? 'opacity-50 cursor-not-allowed' : '');
    // Navigation buttons render as real anchors: browsers treat an anchor click as a
    // genuine user navigation, whereas a programmatic window.open() is silently blocked
    // by popup blockers (Safari, hardened Chrome, kiosk webviews).
    if (href && !disabled) {
      return /*#__PURE__*/React.createElement("a", {
        href: href,
        target: target || '_blank',
        rel: "noopener noreferrer",
        onClick: onClick,
        className: classes,
        "aria-label": ariaLabel || undefined
      }, children);
    }
    return /*#__PURE__*/React.createElement("button", {
      type: type,
      onClick: onClick,
      disabled: disabled,
      className: classes,
      "aria-label": ariaLabel || undefined
    }, children);
  };

  // A collapsible section: a header button with a one-line summary while it is closed. Whether
  // it is open is remembered on this device (best-effort; a blocked localStorage just means the
  // default applies). `right` holds controls that stay usable while the section is closed.
  var SECTION_STORE = 'emsim_sections_v1';
  var readSections = function readSections() {
    try {
      return JSON.parse(localStorage.getItem(SECTION_STORE) || '{}') || {};
    } catch (e) {
      return {};
    }
  };
  // `remember={false}` always starts at defaultOpen and stores nothing (e.g. Quick Sim's ventilator,
  // which starts closed every run however it was left last time).
  var Section = function Section(_ref3) {
    var id = _ref3.id,
      title = _ref3.title,
      summary = _ref3.summary,
      _ref3$defaultOpen = _ref3.defaultOpen,
      defaultOpen = _ref3$defaultOpen === void 0 ? true : _ref3$defaultOpen,
      _ref3$remember = _ref3.remember,
      remember = _ref3$remember === void 0 ? true : _ref3$remember,
      _ref3$right = _ref3.right,
      right = _ref3$right === void 0 ? null : _ref3$right,
      children = _ref3.children,
      _ref3$className = _ref3.className,
      className = _ref3$className === void 0 ? '' : _ref3$className,
      _ref3$tone = _ref3.tone,
      tone = _ref3$tone === void 0 ? 'default' : _ref3$tone;
    var _useState = useState(function () {
        var s = remember ? readSections() : {};
        return typeof s[id] === 'boolean' ? s[id] : defaultOpen;
      }),
      _useState2 = _slicedToArray(_useState, 2),
      open = _useState2[0],
      setOpen = _useState2[1];
    var toggle = function toggle() {
      return setOpen(function (o) {
        var next = !o;
        if (!remember) return next;
        try {
          var s = readSections();
          s[id] = next;
          localStorage.setItem(SECTION_STORE, JSON.stringify(s));
        } catch (e) {/* not stored */}
        return next;
      });
    };
    var bodyId = "section-body-".concat(id);
    var tones = {
      "default": 'border-slate-700 bg-slate-900/70',
      amber: 'border-amber-600/60 bg-amber-950/30',
      violet: 'border-violet-600/60 bg-slate-800',
      card: 'border-slate-700 bg-slate-800'
    };
    return /*#__PURE__*/React.createElement("section", {
      "data-section": id,
      className: "flex-none rounded border ".concat(tones[tone] || tones["default"], " ").concat(className)
    }, /*#__PURE__*/React.createElement("div", {
      className: "flex items-center gap-2 px-2 py-1.5 min-h-[2rem]"
    }, /*#__PURE__*/React.createElement("button", {
      type: "button",
      onClick: toggle,
      "aria-expanded": open,
      "aria-controls": bodyId,
      className: "flex-1 min-w-0 overflow-hidden flex items-center gap-1.5 text-left group"
    }, /*#__PURE__*/React.createElement(Lucide, {
      icon: open ? 'chevron-down' : 'chevron-right',
      className: "w-3.5 h-3.5 flex-none text-slate-400 group-hover:text-white"
    }), /*#__PURE__*/React.createElement("span", {
      className: "text-[10px] uppercase tracking-widest font-bold text-slate-300 group-hover:text-white whitespace-nowrap flex-none"
    }, title), !open && summary ? /*#__PURE__*/React.createElement("span", {
      className: "text-[11px] text-slate-400 truncate min-w-0 ".concat(right ? 'max-md:hidden' : '')
    }, summary) : null), right), open && /*#__PURE__*/React.createElement("div", {
      id: bodyId,
      className: "px-2 pb-2"
    }, children));
  };

  // SIMPLE / FULL VIEW. One setting for this device, shared by every screen that reads it:
  // Simple hides the advanced extras (drug-timing detail, the invasive bulk button, pH and K+,
  // the shock-response settings and the Quick Sim presets); Full shows everything. Simple is the
  // default. Every useViewMode() on the page updates together, and other tabs follow through the
  // storage event. A blocked localStorage just means the choice is not remembered.
  var VIEW_STORE = 'emsim_view_mode_v1';
  var VIEW_EVENT = 'emsim-view-mode';
  var readViewMode = function readViewMode() {
    try {
      return localStorage.getItem(VIEW_STORE) === 'full' ? 'full' : 'simple';
    } catch (e) {
      return 'simple';
    }
  };
  var useViewMode = function useViewMode() {
    var _useState3 = useState(readViewMode),
      _useState4 = _slicedToArray(_useState3, 2),
      mode = _useState4[0],
      setLocal = _useState4[1];
    useEffect(function () {
      var onChange = function onChange(e) {
        return setLocal(e.detail === 'full' ? 'full' : 'simple');
      };
      var onStorage = function onStorage(e) {
        if (e.key === VIEW_STORE) setLocal(readViewMode());
      };
      window.addEventListener(VIEW_EVENT, onChange);
      window.addEventListener('storage', onStorage);
      return function () {
        window.removeEventListener(VIEW_EVENT, onChange);
        window.removeEventListener('storage', onStorage);
      };
    }, []);
    var setMode = function setMode(next) {
      var m = next === 'full' ? 'full' : 'simple';
      try {
        localStorage.setItem(VIEW_STORE, m);
      } catch (e) {/* not stored */}
      window.dispatchEvent(new CustomEvent(VIEW_EVENT, {
        detail: m
      }));
    };
    return [mode, setMode];
  };
  var ViewModeToggle = function ViewModeToggle(_ref4) {
    var _ref4$className = _ref4.className,
      className = _ref4$className === void 0 ? '' : _ref4$className;
    var _useViewMode = useViewMode(),
      _useViewMode2 = _slicedToArray(_useViewMode, 2),
      mode = _useViewMode2[0],
      setMode = _useViewMode2[1];
    var opt = function opt(m, label, tip) {
      return /*#__PURE__*/React.createElement("button", {
        type: "button",
        "aria-pressed": mode === m,
        onClick: function onClick() {
          return setMode(m);
        },
        title: tip,
        className: "px-2 h-full text-[10px] uppercase font-bold ".concat(mode === m ? 'bg-slate-200 text-slate-900' : 'text-slate-300 hover:text-white')
      }, label);
    };
    return /*#__PURE__*/React.createElement("div", {
      role: "group",
      "aria-label": "View",
      "data-testid": "view-mode",
      className: "h-8 flex items-stretch rounded border border-slate-600 overflow-hidden ".concat(className)
    }, opt('simple', 'Simple', 'Simple view: hides the advanced extras (drug-timing detail, pH and K+, shock-response settings, presets)'), opt('full', 'Full', 'Full view: every control'));
  };

  // A compact age for patient strips: "40y" from 2 years, otherwise "4 months", "3 weeks", "newborn"
  // (infant ages are fractional years, which printed as "0.33y").
  window.shortAge = function (age) {
    var a = Number(age);
    if (Number.isFinite(a) && a >= 2) return "".concat(Math.floor(a), "y");
    return window.formatAge ? window.formatAge(age) : "".concat(age, "y");
  };

  // A small drop-down menu for the controller's top bar. Items: { label, icon, onClick } or
  // { label, icon, href } (opened in a new tab, like the buttons they replace). Closes on a
  // choice, an outside click or Escape.
  var MenuButton = function MenuButton(_ref5) {
    var label = _ref5.label,
      icon = _ref5.icon,
      items = _ref5.items,
      _ref5$className = _ref5.className,
      className = _ref5$className === void 0 ? '' : _ref5$className,
      _ref5$ariaLabel = _ref5.ariaLabel,
      ariaLabel = _ref5$ariaLabel === void 0 ? null : _ref5$ariaLabel;
    var _useState5 = useState(false),
      _useState6 = _slicedToArray(_useState5, 2),
      open = _useState6[0],
      setOpen = _useState6[1];
    // Opens towards whichever side has room: right-aligned, a menu whose button sits near the
    // left of a phone screen ran off the left edge.
    var _useState7 = useState(false),
      _useState8 = _slicedToArray(_useState7, 2),
      alignLeft = _useState8[0],
      setAlignLeft = _useState8[1];
    var ref = useRef(null);
    useEffect(function () {
      if (!open) return;
      var onDown = function onDown(e) {
        if (ref.current && !ref.current.contains(e.target)) setOpen(false);
      };
      var onKey = function onKey(e) {
        if (e.key === 'Escape') setOpen(false);
      };
      document.addEventListener('pointerdown', onDown);
      document.addEventListener('keydown', onKey);
      var first = ref.current && ref.current.querySelector('[role="menuitem"]');
      if (first) first.focus();
      return function () {
        document.removeEventListener('pointerdown', onDown);
        document.removeEventListener('keydown', onKey);
      };
    }, [open]);
    var itemClass = 'w-full flex items-center gap-2 px-3 py-2 rounded text-left text-sm text-slate-200 hover:bg-slate-700 focus:bg-slate-700 outline-none whitespace-nowrap';
    return /*#__PURE__*/React.createElement("div", {
      className: "relative",
      ref: ref
    }, /*#__PURE__*/React.createElement("button", {
      type: "button",
      "aria-haspopup": "menu",
      "aria-expanded": open,
      "aria-label": ariaLabel || undefined,
      onClick: function onClick() {
        var r = ref.current && ref.current.getBoundingClientRect();
        setAlignLeft(!!r && r.right < 240);
        setOpen(function (o) {
          return !o;
        });
      },
      className: "h-8 px-2 sm:px-3 rounded font-bold text-sm flex items-center gap-1 border bg-transparent transition-colors ".concat(open ? 'border-slate-400 text-white' : 'border-slate-600 text-slate-300 hover:border-slate-400 hover:text-white', " ").concat(className)
    }, icon && /*#__PURE__*/React.createElement(Lucide, {
      icon: icon,
      className: "w-4 h-4"
    }), " ", label, " ", /*#__PURE__*/React.createElement(Lucide, {
      icon: "chevron-down",
      className: "w-3 h-3"
    })), open && /*#__PURE__*/React.createElement("div", {
      role: "menu",
      className: "absolute ".concat(alignLeft ? 'left-0' : 'right-0', " top-9 z-50 min-w-[14rem] max-w-[calc(100vw-1rem)] bg-slate-800 border border-slate-600 rounded shadow-2xl p-1")
    }, items.filter(Boolean).map(function (it) {
      return it.href ? /*#__PURE__*/React.createElement("a", {
        key: it.label,
        role: "menuitem",
        href: it.href,
        target: "_blank",
        rel: "noopener noreferrer",
        onClick: function onClick() {
          return setOpen(false);
        },
        className: itemClass
      }, it.icon && /*#__PURE__*/React.createElement(Lucide, {
        icon: it.icon,
        className: "w-4 h-4 flex-none text-slate-400"
      }), it.label) : /*#__PURE__*/React.createElement("button", {
        key: it.label,
        type: "button",
        role: "menuitem",
        onClick: function onClick() {
          setOpen(false);
          it.onClick();
        },
        className: itemClass
      }, it.icon && /*#__PURE__*/React.createElement(Lucide, {
        icon: it.icon,
        className: "w-4 h-4 flex-none text-slate-400"
      }), it.label, it.hint && /*#__PURE__*/React.createElement("span", {
        className: "ml-auto pl-3 text-[10px] uppercase text-slate-400"
      }, it.hint));
    })));
  };

  // Shared modal shell: gives every overlay a dialog contract, keeps focus inside it, and restores
  // the invoking control when it closes. The visually-hidden label works even where a modal has a
  // custom visible heading.
  // `fixed` pins it to the screen wherever it is rendered (e.g. from inside a long list, where an
  // absolute overlay would be centred on the list rather than on what the user is looking at).
  var Modal = function Modal(_ref6) {
    var label = _ref6.label,
      onClose = _ref6.onClose,
      children = _ref6.children,
      _ref6$className = _ref6.className,
      className = _ref6$className === void 0 ? '' : _ref6$className,
      _ref6$fixed = _ref6.fixed,
      fixed = _ref6$fixed === void 0 ? false : _ref6$fixed;
    var dialogRef = useRef(null);
    var returnFocusRef = useRef(null);
    var closeRef = useRef(onClose);
    closeRef.current = onClose;
    var labelIdRef = useRef("modal-label-".concat(Math.random().toString(36).slice(2)));
    useEffect(function () {
      returnFocusRef.current = document.activeElement;
      var focusDialog = function focusDialog() {
        var _dialogRef$current, _ref7;
        var focusable = (_dialogRef$current = dialogRef.current) === null || _dialogRef$current === void 0 ? void 0 : _dialogRef$current.querySelector('button:not([disabled]), [href], input:not([disabled]), select:not([disabled]), textarea:not([disabled]), [tabindex]:not([tabindex="-1"])');
        (_ref7 = focusable || dialogRef.current) === null || _ref7 === void 0 || _ref7.focus();
      };
      var timer = setTimeout(focusDialog, 0);
      var onKeyDown = function onKeyDown(event) {
        if (event.key === 'Escape') {
          var _closeRef$current;
          event.preventDefault();
          (_closeRef$current = closeRef.current) === null || _closeRef$current === void 0 || _closeRef$current.call(closeRef);
          return;
        }
        if (event.key !== 'Tab' || !dialogRef.current) return;
        var focusables = Array.from(dialogRef.current.querySelectorAll('button:not([disabled]), [href], input:not([disabled]), select:not([disabled]), textarea:not([disabled]), [tabindex]:not([tabindex="-1"])'));
        if (!focusables.length) {
          event.preventDefault();
          dialogRef.current.focus();
          return;
        }
        var first = focusables[0],
          last = focusables[focusables.length - 1];
        if (!focusables.includes(document.activeElement)) {
          event.preventDefault();
          (event.shiftKey ? last : first).focus();
        } else if (event.shiftKey && document.activeElement === first) {
          event.preventDefault();
          last.focus();
        } else if (!event.shiftKey && document.activeElement === last) {
          event.preventDefault();
          first.focus();
        }
      };
      document.addEventListener('keydown', onKeyDown);
      return function () {
        var _returnFocusRef$curre, _returnFocusRef$curre2;
        clearTimeout(timer);
        document.removeEventListener('keydown', onKeyDown);
        (_returnFocusRef$curre = returnFocusRef.current) === null || _returnFocusRef$curre === void 0 || (_returnFocusRef$curre2 = _returnFocusRef$curre.focus) === null || _returnFocusRef$curre2 === void 0 || _returnFocusRef$curre2.call(_returnFocusRef$curre);
      };
    }, []);
    var overlay =
    /*#__PURE__*/
    // max-md:fixed — on a phone the controller is one long scrolling page, so an absolutely
    // positioned overlay was centred in the middle of that page (jumping the view away from
    // the obs); fixed keeps every dialog over the screen the facilitator is looking at.
    React.createElement("div", {
      className: "".concat(fixed ? 'fixed' : 'absolute max-md:fixed', " inset-0 z-50 bg-black/90 flex items-center justify-center p-4 backdrop-blur-sm max-md:overflow-y-auto")
    }, /*#__PURE__*/React.createElement("div", {
      ref: dialogRef,
      role: "dialog",
      "aria-modal": "true",
      "aria-labelledby": labelIdRef.current,
      tabIndex: "-1",
      className: className
    }, /*#__PURE__*/React.createElement("span", {
      id: labelIdRef.current,
      className: "sr-only"
    }, label), children));
    // Fixed overlays go to <body>: an ancestor with a transform (e.g. the fade-in animation)
    // would otherwise become their containing block.
    return fixed && window.ReactDOM && window.ReactDOM.createPortal ? window.ReactDOM.createPortal(overlay, document.body) : overlay;
  };
  var formatVitalValue = function formatVitalValue(value, decimals) {
    if (!Number.isFinite(value)) return '--';
    return Number.isInteger(decimals) ? (Math.round(value * Math.pow(10, decimals)) / Math.pow(10, decimals)).toFixed(decimals) : value;
  };
  var Card = function Card(_ref8) {
    var children = _ref8.children,
      title = _ref8.title,
      _ref8$className = _ref8.className,
      className = _ref8$className === void 0 ? '' : _ref8$className;
    return /*#__PURE__*/React.createElement("div", {
      className: "bg-slate-800 rounded border border-slate-700 p-4 ".concat(className)
    }, title && /*#__PURE__*/React.createElement("h3", {
      className: "text-sm font-bold text-slate-400 uppercase mb-2"
    }, title), children);
  };

  // =========================================================================================
  // ECGMonitor
  //
  // ROOT CAUSE OF THE REPORTED "ECG LOOKS IRREGULAR WHILE THE RATE RAMPS":
  // every trace derived its cycle position from ABSOLUTE animation time multiplied by the
  // CURRENT instantaneous rate — `const cycleT = (time * ecgFreq) % 1;`, with
  // `ecgFreq = live.hr / 60`. With a static HR that is fine. The moment the HR changes, the
  // WHOLE history is retroactively reinterpreted at the new rate: at t = 20 s, HR 75 puts the
  // cycle at phase 0.00 and HR 76 puts it at 0.33. Measured on the real draw loop, a
  // 75 -> 130 bpm ramp over 30 s produced a single-frame phase jump of up to 0.505 cycle and an
  // R-R coefficient of variation of 41.8% (0.4% at a static rate) with 13 of 51 intervals
  // getting LONGER while the rate rose. Sinus rhythm looked irregular because it WAS being
  // drawn irregular. The pleth (28.2% CV) and the resp trace (36.9% CV through an RR ramp) had
  // exactly the same defect.
  //
  // THE FIX: PHASE ACCUMULATORS. `ecgPhase` and `respPhase` increase monotonically and are
  // advanced each frame by `deltaTime * currentRate`, so a beat that has been drawn can never
  // move and only the spacing of FUTURE beats responds to a rate change — which is what a real
  // monitor does. The integer part of `ecgPhase` is the beat index, which is also what makes
  // per-beat irregularity (AF, flutter with variable block, Mobitz II dropped beats) expressible
  // and stable: see RHYTHMS.beatIntervalFactor / RHYTHMS.droppedBeat.
  //
  // ALSO: PER-TRACE TIME BASES. Real monitors draw the capnogram slower than the ECG so
  // several breaths are visible at once: monitors offer 6.25, 12.5 or 25 mm/s for CO2 against
  // 25 mm/s for the ECG, and the ZOLL R Series draws its capnogram at half the ECG speed
  // ("8 or 10 seconds of data"). The CO2 lane here runs at half the ECG speed (12.5 mm/s
  // against 25 mm/s): 16 s per sweep against the ECG's 8 s. That shows three or more breaths
  // at normal rates while keeping each breath wide enough to read its SHAPE on the narrow
  // controller panel (at 6.25 mm/s a breath there is barely 50 px wide). Each trace is a LANE
  // with its own sweep duration and sweep cursor; phase accumulation is independent of sweep
  // speed, so the slower time base cannot reintroduce the phase defect.
  // =========================================================================================
  var SWEEP_SECONDS = {
    ecg: 8,
    pleth: 8,
    art: 8,
    resp: 8,
    co2: 16
  };
  // Respiratory swing (pulse pressure variation, e.g. hypovolaemia): the pulse height rises and
  // falls with each breath. Returns the pulse size as a fraction of normal, 0.6 to 1.
  var respSwing = function respSwing(respCycle) {
    return 1 - 0.4 * (0.5 - 0.5 * Math.cos(2 * Math.PI * respCycle));
  };
  var ECGMonitor = function ECGMonitor(_ref9) {
    var rhythmType = _ref9.rhythmType,
      hr = _ref9.hr,
      rr = _ref9.rr,
      spO2 = _ref9.spO2,
      etco2 = _ref9.etco2,
      isPaused = _ref9.isPaused,
      showTraces = _ref9.showTraces,
      showEtco2 = _ref9.showEtco2,
      showArt = _ref9.showArt,
      _ref9$co2Pathology = _ref9.co2Pathology,
      co2Pathology = _ref9$co2Pathology === void 0 ? 'normal' : _ref9$co2Pathology,
      _ref9$co2Severity = _ref9.co2Severity,
      co2Severity = _ref9$co2Severity === void 0 ? 0 : _ref9$co2Severity,
      _ref9$ventilating = _ref9.ventilating,
      ventilating = _ref9$ventilating === void 0 ? true : _ref9$ventilating,
      _ref9$isCPR = _ref9.isCPR,
      isCPR = _ref9$isCPR === void 0 ? false : _ref9$isCPR,
      _ref9$className = _ref9.className,
      className = _ref9$className === void 0 ? '' : _ref9$className,
      _ref9$cprBadge = _ref9.cprBadge,
      cprBadge = _ref9$cprBadge === void 0 ? true : _ref9$cprBadge,
      rhythmLabel = _ref9.rhythmLabel,
      _ref9$showSyncMarkers = _ref9.showSyncMarkers,
      showSyncMarkers = _ref9$showSyncMarkers === void 0 ? false : _ref9$showSyncMarkers,
      _ref9$noise = _ref9.noise,
      noise = _ref9$noise === void 0 ? null : _ref9$noise,
      _ref9$showEcg = _ref9.showEcg,
      showEcg = _ref9$showEcg === void 0 ? true : _ref9$showEcg,
      showPleth = _ref9.showPleth,
      showResp = _ref9.showResp,
      _ref9$reserveLanes = _ref9.reserveLanes,
      reserveLanes = _ref9$reserveLanes === void 0 ? [] : _ref9$reserveLanes;
    var canvasRef = useRef(null);
    var _useState9 = useState(0),
      _useState0 = _slicedToArray(_useState9, 2),
      width = _useState0[0],
      setWidth = _useState0[1];
    var plethOn = showPleth === undefined ? !!showTraces : !!showPleth;
    var respOn = showResp === undefined ? !!showTraces : !!showResp;
    var artOn = !!showTraces && !!showArt;
    var co2On = !!showTraces && !!showEtco2;
    var drawn = {
      ecg: !!showEcg,
      pleth: plethOn,
      art: artOn,
      resp: respOn,
      co2: co2On
    };
    var reserved = (reserveLanes || []).reduce(function (m, k) {
      m[k] = true;
      return m;
    }, {});
    // ONE lane order, shared by the draw loop and the labels, so a label can never sit over
    // the wrong trace. A lane is laid out if its trace is drawn OR it is reserved.
    var LANE_ORDER = ['ecg', 'pleth', 'art', 'resp', 'co2'];
    var layoutKeys = LANE_ORDER.filter(function (k) {
      return drawn[k] || reserved[k];
    });
    var drawnKeys = layoutKeys.filter(function (k) {
      return drawn[k];
    });
    var layoutSig = layoutKeys.join(',');
    var drawnSig = drawnKeys.join(',');

    // The animation state outlives any single run of the draw effect. Attaching or detaching a
    // sensor re-runs the effect; previously every re-run restarted the phase accumulators and
    // the sweep cursors from zero AND left the old picture on the canvas, so a removed trace
    // stayed on screen until the sweep happened to overwrite it (8 s, 30 s for CO2) — and
    // stayed FOREVER when no drawn lane was left to sweep over it.
    var traceNoise = noise || {};
    var animRef = useRef(null);
    if (animRef.current === null) animRef.current = {
      time: 0,
      ecgPhase: 0,
      respPhase: 0,
      lanes: {},
      layoutSig: null,
      drawnSig: '',
      // The flush count already seen, so mounting mid-session never replays an old flush.
      flushSeen: Number(traceNoise.artFlush) || 0,
      flushAt: null
    };

    // Keep frequently-changing values in refs so vitals updates don't tear down
    // and restart the animation loop (which would reset the sweep cursors and leave stale
    // trace to the right of the sweep).
    var liveRef = useRef({
      rhythmType: rhythmType,
      hr: hr,
      rr: rr,
      spO2: spO2,
      etco2: etco2,
      co2Pathology: co2Pathology,
      co2Severity: co2Severity,
      ventilating: ventilating,
      isCPR: isCPR,
      showSyncMarkers: showSyncMarkers,
      noise: traceNoise
    });
    liveRef.current = {
      rhythmType: rhythmType,
      hr: hr,
      rr: rr,
      spO2: spO2,
      etco2: etco2,
      co2Pathology: co2Pathology,
      co2Severity: co2Severity,
      ventilating: ventilating,
      isCPR: isCPR,
      showSyncMarkers: showSyncMarkers,
      noise: traceNoise
    };

    // Rhythm resolution and waveform evaluation are delegated ENTIRELY to the registry
    // (data/rhythms.js). WAVE 7 removed the last of the duplicated evaluation logic that used
    // to live here — including a local Mobitz II branch that keyed the dropped beat to
    // `Math.floor(absTime / 1.2)` and produced a DIFFERENT dropped complex from the registry's.
    // `beat` is the beat index from the phase accumulator, so the drop is correct at any rate.
    // `hr` is the BASE rate being drawn; the registry adds each beat's own irregularity and
    // turns the phase into seconds so every complex keeps its real width at any rate.
    var ecgLead = String(rhythmLabel || '').toUpperCase().indexOf('PADS') !== -1 ? 'PADS' : 'II';
    var getECGValue = function getECGValue(cyclePhase, type, cpr, absTime, beat, hr) {
      return RG.ecgValue(cyclePhase, absTime, type, {
        cpr: cpr,
        beat: beat,
        hr: hr,
        lead: ecgLead
      });
    };
    useEffect(function () {
      var canvas = canvasRef.current;
      if (!canvas) return;
      var ctx = canvas.getContext('2d');
      var animationFrameId;
      var anim = animRef.current;
      var time = anim.time; // absolute animation seconds — chaotic (VF) and dissociated
      // (AF baseline, CHB P waves, flutter sawtooth) components only
      var lastTs = null;

      // ---- PHASE ACCUMULATORS (the Wave 7 fix). Monotonically increasing, never recomputed
      // from absolute time, so past beats are immutable. Carried across effect re-runs.
      var ecgPhase = anim.ecgPhase; // cardiac cycles since mount; Math.floor() is the beat index
      var respPhase = anim.respPhase; // respiratory cycles since mount

      // ---- per-lane sweep cursors. Each trace sweeps at its own speed, so they must not
      // share an x position or a lastY. Carried across re-runs so toggling one sensor does not
      // restart every other trace's sweep.
      var lanes = anim.lanes;
      var laneState = function laneState(key) {
        return lanes[key] || (lanes[key] = {
          x: 0,
          lastY: null
        });
      };

      // ---- BLANK WHAT WAS REMOVED, IMMEDIATELY (paused or not).
      // Layout changed (a lane added or dropped) -> the whole picture is stale: clear it and
      // restart every cursor. Same layout, a trace switched off -> clear just that lane.
      if (canvas.width > 0 && canvas.height > 0) {
        ctx.setTransform(1, 0, 0, 1, 0, 0); // device pixels for the clearing below
        var prevDrawn = anim.drawnSig ? anim.drawnSig.split(',') : [];
        if (anim.layoutSig !== null && anim.layoutSig !== layoutSig) {
          ctx.fillStyle = '#000';
          ctx.fillRect(0, 0, canvas.width, canvas.height);
          Object.keys(lanes).forEach(function (k) {
            return delete lanes[k];
          });
        } else if (anim.layoutSig === layoutSig) {
          var h = canvas.height / Math.max(1, layoutKeys.length);
          prevDrawn.filter(function (k) {
            return drawnKeys.indexOf(k) === -1;
          }).forEach(function (k) {
            var i = layoutKeys.indexOf(k);
            if (i !== -1) {
              ctx.fillStyle = '#000';
              ctx.fillRect(0, h * i, canvas.width, h);
            }
            delete lanes[k];
          });
        }
      }
      anim.layoutSig = layoutSig;
      anim.drawnSig = drawnSig;
      // The backing store is devicePixelRatio times the CSS size (crisp traces on a retina
      // tablet); everything is drawn in CSS pixels through this transform.
      ctx.setTransform(anim.dpr || 1, 0, 0, anim.dpr || 1, 0, 0);
      var _render = function render(ts) {
        if (!canvas.parentElement) return;
        var newWidth = canvas.parentElement.clientWidth;
        var newHeight = canvas.parentElement.clientHeight;
        var dpr = Math.min(3, window.devicePixelRatio || 1);
        if (canvas.width !== Math.round(newWidth * dpr) || canvas.height !== Math.round(newHeight * dpr)) {
          canvas.width = Math.round(newWidth * dpr);
          canvas.height = Math.round(newHeight * dpr);
          anim.dpr = dpr;
          anim.cssW = newWidth;
          anim.cssH = newHeight;
          ctx.setTransform(dpr, 0, 0, dpr, 0, 0);
          setWidth(newWidth);
          ctx.fillStyle = '#000';
          ctx.fillRect(0, 0, newWidth, newHeight);
          // WAVE 7 / resizable controller panel: a resize invalidates every sweep cursor.
          // Without this, a cursor left beyond the new width drew nothing until it wrapped
          // and a stale lastY drew one long diagonal across the strip.
          Object.keys(lanes).forEach(function (k) {
            lanes[k].x = Math.min(lanes[k].x, Math.max(0, newWidth - 1));
            lanes[k].lastY = null;
          });
        }
        if (isPaused) return;

        // Frame-rate-independent timing
        if (lastTs === null) {
          lastTs = ts;
          animationFrameId = requestAnimationFrame(_render);
          return;
        }
        var elapsed = Math.min((ts - lastTs) / 1000, 0.05); // seconds, capped to handle tab blur
        lastTs = ts;
        var live = liveRef.current;
        var W = newWidth,
          Hgt = newHeight;

        // -------- trace layout: one lane per drawn or reserved trace, top to bottom
        var numTraces = Math.max(1, layoutKeys.length);
        var traceHeight = Hgt / numTraces;
        var laneIdx = {};
        layoutKeys.forEach(function (k, i) {
          laneIdx[k] = i;
        });

        // Draws one frame's worth of one lane, advancing that lane's own cursor.
        // `colour` is set immediately before the stroke so a recording context can attribute
        // each stroke to its trace.
        //
        // WAVE 8 (lower-priority live finding): A COMPLEX SITTING EXACTLY AT THE SWEEP CURSOR
        // RENDERED AS A ROUNDED HUMP. Two causes, both here, both fixed:
        //
        //  1. THE WRAP SEAM. The cursor was advanced past the right edge, the segment was
        //     drawn to that off-canvas x, and then `lastY` was thrown away (`lastY = null`)
        //     so the next frame restarted at the left edge from nowhere. A complex straddling
        //     the wrap therefore lost its steep limb and was drawn as a short near-horizontal
        //     stub — which, with `lineCap: 'round'` on a 2 px line, is exactly a rounded hump.
        //     The frame's travel is now SPLIT at the edge: the part before the wrap is drawn to
        //     x = W with the y interpolated at that instant, and drawing continues from x = 0
        //     at the SAME y. Continuity is preserved, nothing is drawn off-canvas, and the
        //     whole frame is still one path and one `stroke()` (two subpaths), so stroke
        //     accounting is unchanged.
        //
        //  2. FRAME-RATE ALIASING OF A NARROW R WAVE. One sample per frame means the R peak
        //     is hit only when a frame lands on it; at 60 bpm/60 fps a frame advances 1.7% of
        //     the cardiac cycle while the R wave occupies ~1%, so some beats were drawn tall
        //     and others clipped — the beat-to-beat amplitude variation the live tester saw.
        //     Callers may now pass SUB-SAMPLES for the frame (see the ECG lane below): the
        //     waveform is evaluated several times within the frame and drawn as a polyline,
        //     so the peak is captured whatever the frame rate.
        //
        // `samples` is an ordered array of y values across this frame; the last one is the
        // value AT the new cursor position. Omitted = one sample, as before.
        var drawLane = function drawLane(key, colour, y, samples) {
          var st = laneState(key);
          var sweep = SWEEP_SECONDS[key] || 8;
          var speed = W / sweep * elapsed;
          var top = traceHeight * laneIdx[key];
          var eraseW = Math.max(3, W / sweep * 0.12);
          // erase bar ahead of this lane's cursor, inside this lane only (wrapping round the
          // right edge so the bar never disappears for a frame)
          ctx.fillStyle = 'rgba(0,0,0,1)';
          ctx.fillRect(st.x, top, eraseW, traceHeight);
          if (st.x + eraseW > W) ctx.fillRect(0, top, st.x + eraseW - W, traceHeight);
          var ys = samples && samples.length ? samples : [y];
          var x0 = st.x; // where the previous frame left the cursor
          ctx.strokeStyle = colour;
          ctx.lineWidth = 2;
          ctx.lineJoin = 'round';
          ctx.lineCap = 'round';
          ctx.beginPath();
          var px = x0,
            py = st.lastY !== null ? st.lastY : ys[0];
          ctx.moveTo(px, py);
          // Once this frame has wrapped to the left edge, every later sub-sample is also
          // past the edge. Without this flag each of them was taken for a NEW wrap and drew
          // a line from the left edge straight across to the right edge (the stray
          // horizontal lines seen after a rhythm change).
          var wrapped = false;
          for (var i = 0; i < ys.length; i++) {
            var nx = x0 + speed * ((i + 1) / ys.length);
            var ny = ys[i];
            if (!wrapped && nx >= W) {
              // split this sub-segment at the right edge, interpolating y at the edge
              var f = (W - px) / Math.max(1e-6, nx - px);
              var edgeY = py + (ny - py) * f;
              ctx.lineTo(W, edgeY);
              ctx.moveTo(0, edgeY); // same path, new subpath: one stroke, no seam
              wrapped = true;
              ctx.lineTo(nx - W, ny);
            } else {
              ctx.lineTo(wrapped ? nx - W : nx, ny);
            }
            px = wrapped ? nx - W : nx;
            py = ny;
          }
          ctx.stroke();
          st.lastY = ys[ys.length - 1];
          st.x = x0 + speed;
          if (st.x >= W) st.x -= W;
          return st;
        };

        // -------- RATE SELECTION (registry-driven).
        // A pulseless ORGANISED rhythm displays HR 0 but still has electrical activity, so it
        // must be drawn at a rhythm-appropriate intrinsic rate instead of silently defaulting
        // to 60/min (PEA previously drew a perfusing-looking trace at whatever rate the
        // numbers happened to hold).
        // RG.drawRate also runs Mobitz II's beat slots at 4/3 of the HR (one in four is
        // dropped), so the QRS drawn per minute always equals the HR shown.
        var rid = RG.canonical(live.rhythmType);
        var ecgFreq;
        if (rid === 'VF') ecgFreq = 4;else if (rid === 'Fine VF') ecgFreq = 5;else if (rid === 'Asystole') ecgFreq = 0.1;else ecgFreq = RG.drawRate(rid, live.hr) / 60;

        // ---- ADVANCE THE PHASE. `beatIntervalFactor` lengthens or shortens INDIVIDUAL beats
        // for the rhythms that are supposed to be irregular; it returns exactly 1 for
        // everything that must stay regular, so a regular rhythm advances at precisely
        // deltaTime * rate and cannot drift.
        var prevEcgPhase = ecgPhase;
        var beatIdx = Math.floor(ecgPhase);
        var factor = RG.beatIntervalFactor ? RG.beatIntervalFactor(rid, beatIdx) : 1;
        ecgPhase += elapsed * ecgFreq / (factor > 0 ? factor : 1);
        var cycleT = ecgPhase - Math.floor(ecgPhase);

        // One breath clock for both respiratory traces: the patient's own rate, or
        // 10/min during CPR (RCUK ventilation rate), or 12/min when no rate is set.
        var respRate = RG.capnoRate(live.rr, live.isCPR);
        respPhase += elapsed * respRate / 60;
        var respCycle = respPhase - Math.floor(respPhase);

        // -------------------------------------------------- ECG
        var ecgBaseY = 0;
        if (showEcg) {
          ecgBaseY = traceHeight * (laneIdx.ecg + 0.5);
          var ecgAmp = rid === 'VF' || rid === 'Fine VF' ? 0.5 : 1;
          // Sub-sample the cardiac cycle WITHIN the frame. The R wave occupies about
          // 1% of the cycle, so one sample per frame could straddle it and clip the peak —
          // the beat-to-beat amplitude wobble seen live. One sample per <=0.4% of the cycle
          // (up to 8) captures the peak at any heart rate and any frame rate, and the whole
          // frame is still drawn as a single path with a single stroke().
          var phaseAdvance = ecgPhase - prevEcgPhase;
          var nSub = Math.max(1, Math.min(8, Math.ceil(phaseAdvance / 0.004)));
          var ecgSamples = [];
          // Artefact (mains hum in particular) needs the full sub-sampling to show.
          var n = live.noise;
          var artefactOn = !!(n.movement || n.interference || n.tremor || n.leadoff);
          var nS = artefactOn ? 8 : nSub;
          for (var i = 1; i <= nS; i++) {
            var f = i / nS;
            var ph = prevEcgPhase + phaseAdvance * f;
            var bi = Math.floor(ph);
            var v = getECGValue(ph - bi, live.rhythmType, live.isCPR, time + elapsed * f, bi, ecgFreq * 60) * ecgAmp;
            if (artefactOn && RG.ecgArtefact) {
              var a = RG.ecgArtefact(n, time + elapsed * f, ecgLead);
              v = a.replace !== undefined ? a.replace : v + a.add * 0.7;
            }
            ecgSamples.push(ecgBaseY - v);
          }
          var ecgY = ecgSamples[ecgSamples.length - 1];
          drawLane('ecg', '#22c55e', ecgY, ecgSamples);

          // R-wave synchronisation markers. When the defibrillator is in SYNC mode the
          // device must visibly mark the R waves it will fire on, otherwise "synchronised"
          // is an invisible flag (which is exactly what it was before Wave 3).
          if (live.showSyncMarkers && !live.isCPR) {
            // The registry says where each beat's R peak is (null for VF, asystole and
            // dropped beats). Phase is monotonic, so "did we cross an R wave this frame?"
            // is a plain comparison on the accumulator.
            var crossed = false;
            for (var b = Math.floor(prevEcgPhase); b <= Math.floor(ecgPhase) && !crossed; b++) {
              var rp = RG.rWavePhase(rid, ecgFreq * 60, b);
              if (rp !== null && prevEcgPhase < b + rp && b + rp <= ecgPhase) crossed = true;
            }
            {
              if (crossed) {
                var st = laneState('ecg');
                ctx.save();
                ctx.strokeStyle = '#facc15';
                ctx.lineWidth = 2;
                ctx.beginPath();
                ctx.moveTo(st.x, ecgBaseY - traceHeight * 0.42);
                ctx.lineTo(st.x, ecgBaseY - traceHeight * 0.30);
                ctx.stroke();
                ctx.restore();
              }
            }
          }
        }

        // -------------------------------------------------- PLETH
        // Driven by the SAME cardiac phase accumulator as the ECG, so there is exactly one
        // pulse wave per QRS and the pleth tracks the heart rate through a ramp by
        // construction rather than by coincidence.
        var pulseless = RG.isPulseless(rid);
        if (plethOn) {
          var spo2BaseY = traceHeight * (laneIdx.pleth + 0.62);
          // No saturation reading, or no output: no pulse wave (a flat pleth is the sign).
          var pStyle = live.noise.pleth || 'normal';
          var pv = live.spO2 < 10 || pulseless ? 0 : RG.pulseValue('pleth', cycleT, rid, {
            hr: ecgFreq * 60,
            beat: Math.floor(ecgPhase),
            style: pStyle
          });
          if (pv > 0 && pStyle === 'swing') pv = pv * respSwing(respCycle) + 3 * Math.sin(2 * Math.PI * respCycle);
          // Poor perfusion: the monitor's auto-gain shows a little noise on a weak signal.
          if (pStyle === 'poor') pv += 0.8 * Math.sin(2 * Math.PI * 3.1 * time) + 0.6 * Math.sin(2 * Math.PI * 7.3 * time + 1);
          // Motion artefact (a moving or shivering hand): large irregular swings swamp the pulse.
          if (pStyle === 'motion') pv += 9 * Math.sin(time * 2 * Math.PI * 1.1) * (0.6 + 0.4 * Math.sin(time * 0.9)) + 5 * Math.sin(time * 2 * Math.PI * 2.7 + 0.5) + (Math.sin(time * 0.8) > 0.9 ? 12 : 0);
          drawLane('pleth', '#3b82f6', spo2BaseY - pv);
        }

        // -------------------------------------------------- ARTERIAL LINE
        // Beat-by-beat radial pressure pulses above a diastolic baseline. Without output the
        // line sits flat near zero; chest compressions generate small pressure waves.
        // A flush pressed while no arterial line is drawn is used up, never replayed later.
        var flushes = Number(live.noise.artFlush) || 0;
        if (flushes !== anim.flushSeen) {
          anim.flushAt = artOn && flushes > anim.flushSeen ? time : null;
          anim.flushSeen = flushes;
        }
        if (artOn) {
          var artBaseY = traceHeight * (laneIdx.art + 0.7);
          var aStyle = live.noise.art || 'normal';
          var av;
          if (pulseless) {
            var c = time * 1.83 % 1;
            av = live.isCPR ? 3 + 15 * Math.exp(-0.5 * Math.pow((c - 0.3) / 0.09, 2)) : 2;
          } else {
            av = 6 + RG.pulseValue('art', cycleT, rid, {
              hr: ecgFreq * 60,
              beat: Math.floor(ecgPhase),
              style: aStyle
            });
            if (aStyle === 'swing') av = 6 + (av - 6) * respSwing(respCycle) + 3 * Math.sin(2 * Math.PI * respCycle);
          }
          // Fast-flush (square wave) test: the pressure jumps off the top of the scale while
          // the flush is held, then drops back and rings according to the damping.
          if (anim.flushAt !== null && RG.flushRelease) {
            var since = time - anim.flushAt;
            var top = traceHeight * 0.55;
            var hold = RG.FLUSH_HOLD_S;
            var style = aStyle === 'swing' ? 'normal' : aStyle;
            if (since < 0.05) av = av + (top - av) * (since / 0.05);else if (since < hold) av = top;else if (since < hold + 1.5) av = av + (top - av) * RG.flushRelease(since - hold, style);else anim.flushAt = null;
          }
          drawLane('art', '#ef4444', artBaseY - av);
        }

        // -------------------------------------------------- RESP (chest-wall impedance)
        // A smooth sinusoid is the CORRECT shape for a thoracic impedance trace. It is a
        // different measurement from capnography, which is drawn below with a real
        // capnogram morphology on its own slower time base.
        // Apnoea (no rate, no CPR, nothing moving gas) is a FLAT line, the same rule as
        // the capnogram: capnoRate's 12/min fallback is only a clock, not a breath.
        if (respOn) {
          var respBaseY = traceHeight * (laneIdx.resp + 0.5);
          var apnoeic = !(Number(live.rr) > 0) && !live.isCPR && !live.ventilating;
          var respY = respBaseY - (apnoeic ? -15 : respImpedance(respCycle, respRate)); // -15: the resting level
          drawLane('resp', '#eab308', respY);
        }

        // -------------------------------------------------- CAPNOGRAPHY (ETCO2)
        // 16 s sweep (half the ECG speed), real capnogram timed in seconds from the same
        // breath clock as the impedance trace, amplitude scaled from the DISPLAYED
        // numeric ETCO2 so the plateau and the number always agree. No ventilation means no
        // capnogram at all (oesophageal intubation / disconnection / apnoea): a flat line is
        // the teaching point, and drawing a waveform there would teach the opposite.
        if (co2On) {
          var co2Lane = traceHeight * laneIdx.co2;
          var co2ZeroY = co2Lane + traceHeight * 0.86; // zero baseline near lane floor
          var co2Scale = traceHeight * 0.72 / 8; // px per kPa (8 kPa full scale)
          var kPa = Number.isFinite(live.etco2) ? live.etco2 : 5.0;
          var co2Y;
          if (!live.ventilating || !(kPa > 0)) {
            co2Y = co2ZeroY; // flat zero, no waveform
          } else {
            // Phase 0 is the start of inspiration, as for the impedance trace, so the
            // capnogram falls to zero exactly while the chest is rising. The
            // obstruction severity scales the shape continuously from a normal
            // trapezoid (0) to an unmistakable shark fin (1). Treating the
            // bronchospasm lowers the severity, so the trace visibly normalises.
            var _v = RG.capnogram(respCycle, kPa, live.co2Pathology, live.co2Severity, respRate);
            // During CPR the capnogram is small and shows the compression rate; ETCO2
            // RISING is the classic sign of ROSC, and that falls out of the numeric
            // value driving the amplitude.
            if (live.isCPR) _v += Math.max(0, kPa * 0.10) * Math.sin(time * 2 * Math.PI * 1.83);
            co2Y = co2ZeroY - _v * co2Scale;
          }
          drawLane('co2', '#a855f7', co2Y);
        }
        time += elapsed;
        anim.time = time;
        anim.ecgPhase = ecgPhase;
        anim.respPhase = respPhase;
        animationFrameId = requestAnimationFrame(_render);
      };
      animationFrameId = requestAnimationFrame(_render);
      return function () {
        return cancelAnimationFrame(animationFrameId);
      };
    }, [isPaused, layoutSig, drawnSig]);

    // Labels follow the SAME lane order the draw loop uses, so a label can never sit over the
    // wrong trace when a sensor is attached or detached mid-session.
    var numTraces = Math.max(1, layoutKeys.length);
    var topOf = function topOf(key) {
      return "calc(".concat(100 / numTraces * layoutKeys.indexOf(key), "% + 4px)");
    };
    // A reserved lane whose sensor is off: blank, with the reason in dim grey.
    var OFF_TEXT = {
      ecg: "".concat(rhythmLabel || 'LEAD II', " \u2014 leads off"),
      pleth: "PLETH \u2014 no probe",
      art: "ART \u2014 off",
      resp: "RESP \u2014 leads off",
      co2: "CO2 \u2014 off"
    };
    var offLanes = layoutKeys.filter(function (k) {
      return !drawn[k];
    });
    // WAVE 7 / BUG 2: the trace labels carry their own opaque chip. The previous fix nudged the
    // controller's overlay buttons sideways, which still clipped "LEAD II" at narrow panel
    // widths; the buttons have now moved OUT of the canvas entirely (see livesim.js) and the
    // chip guarantees the label stays legible against any trace behind it.
    var labelClass = 'absolute left-2 font-mono text-xs font-bold px-1 rounded bg-black/70 pointer-events-none z-20';
    return /*#__PURE__*/React.createElement("div", {
      className: "relative w-full bg-black ".concat(className)
    }, /*#__PURE__*/React.createElement("canvas", {
      ref: canvasRef,
      className: "block w-full h-full"
    }), offLanes.map(function (k) {
      return /*#__PURE__*/React.createElement("div", {
        key: "off-".concat(k),
        className: "".concat(labelClass, " text-slate-400 uppercase tracking-wider"),
        style: {
          top: topOf(k)
        }
      }, OFF_TEXT[k]);
    }), showEcg && /*#__PURE__*/React.createElement("div", {
      className: "".concat(labelClass, " text-green-500"),
      style: {
        top: topOf('ecg')
      }
    }, rhythmLabel || "LEAD II", traceNoise.leadoff && ecgLead !== 'PADS' && /*#__PURE__*/React.createElement("span", {
      className: "ml-1 text-amber-400",
      "data-testid": "ecg-check-leads"
    }, "CHECK LEADS")), plethOn && /*#__PURE__*/React.createElement("div", {
      className: "".concat(labelClass, " text-blue-500"),
      style: {
        top: topOf('pleth')
      }
    }, "PLETH", (traceNoise.pleth === 'poor' || traceNoise.pleth === 'motion') && /*#__PURE__*/React.createElement("span", {
      className: "ml-1 text-amber-400",
      "data-testid": "pleth-poor-signal"
    }, "POOR SIGNAL")), artOn && /*#__PURE__*/React.createElement("div", {
      className: "".concat(labelClass, " text-red-500"),
      style: {
        top: topOf('art')
      }
    }, "ART"), respOn && /*#__PURE__*/React.createElement("div", {
      className: "".concat(labelClass, " text-yellow-500"),
      style: {
        top: topOf('resp')
      }
    }, "RESP"), co2On && /*#__PURE__*/React.createElement("div", {
      className: "".concat(labelClass, " text-purple-500"),
      style: {
        top: topOf('co2')
      },
      title: "Capnogram: 0 to 8 kPa, drawn at half the ECG speed (12.5 mm/s)"
    }, "CO2 ", /*#__PURE__*/React.createElement("span", {
      className: "text-purple-300/80 font-normal"
    }, "0\u20138 kPa")), co2On && !ventilating && /*#__PURE__*/React.createElement("div", {
      className: "absolute right-2 text-purple-300 font-mono text-[10px] font-bold uppercase tracking-wider",
      style: {
        top: topOf('co2')
      }
    }, "no capnogram \u2014 not ventilating"), isCPR && cprBadge && /*#__PURE__*/React.createElement("div", {
      className: "absolute top-2 right-2 bg-red-600 text-white px-2 py-1 text-xs font-bold animate-pulse"
    }, "CPR IN PROGRESS"), showSyncMarkers && !isCPR && /*#__PURE__*/React.createElement("div", {
      className: "absolute bottom-1 right-2 text-yellow-400 font-mono text-[10px] font-bold tracking-widest"
    }, "SYNC"));
  };
  var VitalDisplay = function VitalDisplay(_ref0) {
    var label = _ref0.label,
      value = _ref0.value,
      value2 = _ref0.value2,
      unit = _ref0.unit,
      alert = _ref0.alert,
      prev = _ref0.prev,
      visible = _ref0.visible,
      onClick = _ref0.onClick,
      trend = _ref0.trend,
      isMonitor = _ref0.isMonitor,
      hideTrends = _ref0.hideTrends,
      isNIBP = _ref0.isNIBP,
      lastNIBP = _ref0.lastNIBP,
      note = _ref0.note,
      _ref0$compact = _ref0.compact,
      compact = _ref0$compact === void 0 ? false : _ref0$compact,
      _ref0$medium = _ref0.medium,
      medium = _ref0$medium === void 0 ? false : _ref0$medium,
      _ref0$dense = _ref0.dense,
      dense = _ref0$dense === void 0 ? false : _ref0$dense,
      _ref0$reserveBottom = _ref0.reserveBottom,
      reserveBottom = _ref0$reserveBottom === void 0 ? false : _ref0$reserveBottom,
      _ref0$noCount = _ref0.noCount,
      noCount = _ref0$noCount === void 0 ? false : _ref0$noCount;
    if (!visible) return /*#__PURE__*/React.createElement("div", {
      className: "h-full min-w-0 bg-slate-900 border border-slate-800 rounded flex items-center justify-center opacity-50"
    }, /*#__PURE__*/React.createElement("span", {
      className: "text-slate-400 text-xs uppercase"
    }, label, " Off"));
    var color = "text-green-500";
    if (label === 'SpO2') color = "text-blue-500";
    if (label === 'BP' || label === 'ABP' || label === 'NIBP') color = "text-red-500";
    if (label === 'RR' || label === 'Resp Rate') color = "text-yellow-500";
    if (label === 'ETCO2') color = "text-purple-500";
    if (label === 'Temp') color = "text-white";
    if (label === 'Glucose') color = "text-white";
    if (label === 'pH') color = "text-white";
    if (noCount) color = "text-red-500";
    // The room monitor's numbers grow with their tile (index.html .obs-tile / .obs-num: container
    // units, so a TV, a tablet and a half-width window all get the largest number that fits).
    var scaled = isMonitor && !compact && !medium;
    var trendIcon = trend !== null && trend !== void 0 && trend.active && Number.isFinite(trend.target) && Number.isFinite(value) ? trend.target > value ? '↑' : trend.target < value ? '↓' : '' : '';

    // A pulseless arrest legitimately reads 0/0, so truthiness is the wrong test here. All
    // numeric fields use one finite-value formatter; the only text vital is the pupil descriptor.
    var hasValue2 = Number.isFinite(value2);
    var show = function show(v) {
      return label === 'Pupils' && typeof v === 'string'
      // pH needs 2 dp and temp/glucose 1 dp, otherwise a modelled value like 7.35 or 36.85
      // would render at full float precision on the tile.
      ? v : formatVitalValue(v, label === 'pH' ? 2 : label === 'ETCO2' || label === 'Temp' || label === 'Glucose' ? 1 : undefined);
    };
    var shown = function shown(v) {
      return noCount ? '---' : show(v);
    };
    var Tile = onClick ? 'button' : 'div';
    var tileProps = onClick ? {
      type: 'button',
      onClick: onClick,
      'aria-label': "Adjust ".concat(label)
    } : {};
    if (isNIBP && isMonitor) {
      return /*#__PURE__*/React.createElement(Tile, _extends({}, tileProps, {
        className: "obs-tile relative h-full w-full min-w-0 overflow-hidden bg-slate-900 border-2 rounded p-2 ".concat(reserveBottom ? 'pb-14 max-md:pb-11 [@media(orientation:landscape)_and_(max-height:500px)]:pb-10' : '', " flex flex-col justify-between text-left ").concat(onClick ? 'cursor-pointer' : '', " transition-colors ").concat(alert ? 'border-red-500 bg-red-900/20' : 'border-slate-800')
      }), /*#__PURE__*/React.createElement("div", {
        className: "flex justify-between items-start gap-1 min-w-0"
      }, /*#__PURE__*/React.createElement("span", {
        className: "".concat(dense ? 'text-[10px] lg:text-sm' : 'text-sm', " font-bold uppercase truncate ").concat(color)
      }, label), /*#__PURE__*/React.createElement("span", {
        className: "text-xs text-slate-400 whitespace-nowrap"
      }, unit)), /*#__PURE__*/React.createElement("div", {
        className: "flex items-end justify-center gap-1 my-1 whitespace-nowrap min-w-0"
      }, /*#__PURE__*/React.createElement("span", {
        className: "obs-num obs-nibp font-mono font-bold leading-none ".concat(color)
      }, show(value)), /*#__PURE__*/React.createElement("span", {
        className: "obs-nibp-slash text-slate-400 font-bold mb-1"
      }, "/"), /*#__PURE__*/React.createElement("span", {
        className: "obs-num obs-nibp obs-nibp-dia font-mono font-bold leading-none ".concat(color)
      }, show(value2))), /*#__PURE__*/React.createElement("div", {
        className: "text-right text-[10px] text-slate-400 uppercase font-mono mt-auto whitespace-nowrap truncate"
      }, note && /*#__PURE__*/React.createElement("span", {
        className: "mr-2 px-1 rounded border border-slate-600 text-slate-300 font-bold tracking-wider"
      }, note), lastNIBP ? "Last: ".concat(new Date(lastNIBP).toLocaleTimeString([], {
        hour: '2-digit',
        minute: '2-digit'
      })) : 'No reading'));
    }
    if (compact) {
      return /*#__PURE__*/React.createElement(Tile, _extends({}, tileProps, {
        className: "relative bg-slate-900 border rounded px-1.5 pt-1 ".concat(note ? 'pb-3' : 'pb-1', " flex flex-col text-left min-w-0 ").concat(onClick ? 'cursor-pointer active:bg-slate-800' : '', " overflow-hidden ").concat(alert ? 'border-red-500 bg-red-900/20' : 'border-slate-700')
      }), /*#__PURE__*/React.createElement("div", {
        className: "flex justify-between items-baseline gap-1 min-w-0"
      }, /*#__PURE__*/React.createElement("span", {
        className: "text-[10px] font-bold uppercase leading-none ".concat(color)
      }, label), unit && /*#__PURE__*/React.createElement("span", {
        className: "text-[9px] text-slate-400 leading-none truncate"
      }, unit)), /*#__PURE__*/React.createElement("div", {
        className: "font-mono font-bold leading-tight tracking-tight text-center whitespace-nowrap ".concat(color, " ").concat(hasValue2 ? 'text-xl' : 'text-2xl')
      }, hasValue2 ? "".concat(show(value), "/").concat(show(value2)) : show(value), trendIcon && /*#__PURE__*/React.createElement("span", {
        className: "text-sm text-sky-400 ml-0.5"
      }, trendIcon)), note && /*#__PURE__*/React.createElement("span", {
        "data-off-monitor": note === 'not on monitor' ? '' : undefined,
        className: "absolute left-1.5 right-1 bottom-0.5 text-[8px] leading-none uppercase tracking-wide font-bold text-amber-400/90 truncate pointer-events-none"
      }, note), !hideTrends && trend && trend.active && /*#__PURE__*/React.createElement("div", {
        className: "absolute left-0 right-0 bottom-0 h-0.5 bg-slate-800"
      }, /*#__PURE__*/React.createElement("div", {
        className: "bg-sky-500 h-full",
        style: {
          width: "".concat(trend.progress * 100, "%")
        }
      })));
    }
    return /*#__PURE__*/React.createElement(Tile, _extends({}, tileProps, {
      className: "".concat(scaled ? 'obs-tile ' : '', "relative min-w-0 bg-slate-900 border-2 rounded p-2 flex flex-col justify-between ").concat(onClick ? 'cursor-pointer' : '', " transition-colors overflow-hidden ").concat(alert ? 'border-red-500 bg-red-900/20 animate-pulse' : 'border-slate-800 hover:border-slate-600')
    }), /*#__PURE__*/React.createElement("div", {
      className: "flex justify-between items-start gap-1 min-w-0"
    }, /*#__PURE__*/React.createElement("span", {
      className: "".concat(dense ? 'text-[10px] lg:text-sm' : 'text-xs md:text-sm', " font-bold uppercase truncate ").concat(color)
    }, label), /*#__PURE__*/React.createElement("span", {
      className: "text-[10px] md:text-xs text-slate-400 whitespace-nowrap"
    }, unit)), /*#__PURE__*/React.createElement("div", {
      className: "flex ".concat(scaled ? 'items-center' : 'items-baseline', " justify-center gap-1 h-full mt-2 min-w-0 whitespace-nowrap")
    }, /*#__PURE__*/React.createElement("span", {
      "data-testid": isMonitor ? "obs-".concat(label.replace(/\W+/g, '-').toLowerCase()) : undefined,
      className: "".concat(scaled ? hasValue2 ? 'obs-num obs-v2' : 'obs-num' : medium ? hasValue2 ? 'text-2xl md:text-3xl lg:text-4xl' : 'text-4xl md:text-5xl lg:text-6xl' : hasValue2 ? 'text-3xl md:text-4xl lg:text-5xl' : 'text-5xl md:text-7xl lg:text-8xl', " font-mono font-bold tracking-tight ").concat(color)
    }, hasValue2 ? "".concat(shown(value), "/").concat(shown(value2)) : shown(value)), trendIcon && /*#__PURE__*/React.createElement("span", {
      className: "text-xl md:text-3xl text-sky-400 absolute right-2 top-1/2 -translate-y-1/2"
    }, trendIcon)), note && /*#__PURE__*/React.createElement("span", {
      className: "absolute right-2 top-6 md:top-7 text-right text-[9px] leading-none uppercase tracking-wider font-bold text-amber-400/90 pointer-events-none"
    }, note), !hideTrends && trend && trend.active && /*#__PURE__*/React.createElement("div", {
      className: "w-full bg-slate-800 h-1 mt-2 rounded overflow-hidden"
    }, /*#__PURE__*/React.createElement("div", {
      className: "bg-sky-500 h-full transition-all duration-1000",
      style: {
        width: "".concat(trend.progress * 100, "%")
      }
    })));
  };

  // A render error anywhere below React's root unmounts the whole tree and leaves a blank page
  // that only a reload recovers from. This keeps the facilitator in the app with a way out.
  var ErrorBoundary = /*#__PURE__*/function (_React$Component) {
    function ErrorBoundary(props) {
      var _this;
      _classCallCheck(this, ErrorBoundary);
      _this = _callSuper(this, ErrorBoundary, [props]);
      _this.state = {
        error: null
      };
      return _this;
    }
    _inherits(ErrorBoundary, _React$Component);
    return _createClass(ErrorBoundary, [{
      key: "componentDidCatch",
      value: function componentDidCatch(error, info) {
        console.error("Render error caught by boundary:", error, info);
      }
    }, {
      key: "render",
      value: function render() {
        var _this2 = this;
        if (!this.state.error) return this.props.children;
        return /*#__PURE__*/React.createElement("div", {
          className: "h-full w-full flex items-center justify-center p-6 bg-slate-900"
        }, /*#__PURE__*/React.createElement("div", {
          className: "max-w-lg w-full bg-slate-800 border border-red-500/60 rounded-lg p-6 shadow-2xl space-y-4"
        }, /*#__PURE__*/React.createElement("h2", {
          className: "text-xl font-bold text-red-400"
        }, "Something went wrong"), /*#__PURE__*/React.createElement("p", {
          className: "text-sm text-slate-300"
        }, "This screen failed to render. Your session was not lost \u2014 you can return to the main menu and start or reload a scenario."), /*#__PURE__*/React.createElement("pre", {
          className: "text-[11px] text-slate-400 bg-slate-900 border border-slate-700 rounded p-2 overflow-x-auto whitespace-pre-wrap"
        }, String(this.state.error && this.state.error.message || this.state.error)), /*#__PURE__*/React.createElement("div", {
          className: "flex gap-2"
        }, /*#__PURE__*/React.createElement(Button, {
          variant: "primary",
          className: "flex-1",
          onClick: function onClick() {
            _this2.setState({
              error: null
            });
            if (_this2.props.onReset) _this2.props.onReset();
          }
        }, "Return to Main Menu"), /*#__PURE__*/React.createElement(Button, {
          variant: "outline",
          className: "flex-1",
          onClick: function onClick() {
            return window.location.reload();
          }
        }, "Reload App"))));
      }
    }], [{
      key: "getDerivedStateFromError",
      value: function getDerivedStateFromError(error) {
        return {
          error: error
        };
      }
    }]);
  }(React.Component); // Human factors modifier indicator — must stay visible for the whole sim so the facilitator
  // does not forget which constraint the team is working under.
  var HumanFactorBadge = function HumanFactorBadge(_ref1) {
    var hf = _ref1.hf,
      _ref1$className = _ref1.className,
      className = _ref1$className === void 0 ? "" : _ref1$className;
    if (!hf || !hf.type || hf.id === 'hf0') return null;
    return /*#__PURE__*/React.createElement("span", {
      title: hf.description || '',
      className: "inline-flex items-center gap-1 bg-fuchsia-900/40 border border-fuchsia-500/60 text-fuchsia-300 text-[10px] font-bold uppercase tracking-wider px-2 py-1 rounded ".concat(className)
    }, /*#__PURE__*/React.createElement(Lucide, {
      icon: "user",
      className: "w-3 h-3"
    }), "Human Factor: ", hf.type);
  };
  window.Lucide = Lucide;
  window.ErrorBoundary = ErrorBoundary;
  window.HumanFactorBadge = HumanFactorBadge;
  window.Button = Button;
  window.Modal = Modal;
  window.Section = Section;
  window.MenuButton = MenuButton;
  window.useViewMode = useViewMode;
  window.ViewModeToggle = ViewModeToggle;
  window.Card = Card;
  window.ECGMonitor = ECGMonitor;
  window.VitalDisplay = VitalDisplay;
})();